/* Variant updater – lightweight replacement for Dawn's product-info.js */
(() => {
  function getVariantData(root) {
    try {
      const tag = root.querySelector('script[type="application/json"]');
      return tag ? JSON.parse(tag.textContent) : [];
    } catch (e) {
      console.warn('Variant JSON parse error', e);
      return [];
    }
  }

  function selectedOptions(root) {
    const values = [];
    root.querySelectorAll('select').forEach(s => values.push(s.value));
    root.querySelectorAll('input[type="radio"]:checked').forEach(r => values.push(r.value));
    return values;
  }

  function findVariant(variants, values) {
    return variants.find(v =>
      Array.isArray(v.options) &&
      v.options.length === values.length &&
      v.options.every((opt, i) => opt === values[i])
    );
  }

  function replaceFromDoc(doc, selector) {
    const fresh = doc.querySelector(selector);
    const live  = document.querySelector(selector);
    if (fresh && live) live.replaceWith(fresh);
  }

  function updatePieces(root, variant) {
    const sectionId = root.dataset.sectionId || root.dataset.section;
    const productUrl = root.dataset.url;
    if (!sectionId || !productUrl) return;

    const url = `${productUrl}?variant=${variant.id}&section_id=${sectionId}`;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // swap price, inventory, sku, gallery
        replaceFromDoc(doc, `#price-${sectionId}`);
        replaceFromDoc(doc, `#Inventory-${sectionId}`);
        replaceFromDoc(doc, `#Sku-${sectionId}`);
        replaceFromDoc(doc, `#MediaGallery-${sectionId}`);

        // swap add-to-cart form (keeps availability/disabled state correct)
        const freshForm = doc.querySelector(`#ProductInfo-${sectionId} form[action*="/cart/add"]`);
        const liveForm  = document.querySelector(`#ProductInfo-${sectionId} form[action*="/cart/add"]`);
        if (freshForm && liveForm) liveForm.replaceWith(freshForm);

        // ensure hidden input has the new variant id
        const idInput = document.querySelector(`#ProductInfo-${sectionId} input[name="id"]`);
        if (idInput) idInput.value = variant.id;
      })
      .catch(err => console.error('Variant fetch failed', err));
  }

  function onChange(e) {
    const root = e.currentTarget;
    const variants = getVariantData(root);
    const values   = selectedOptions(root);
    const variant  = findVariant(variants, values);
    if (!variant) return;

    // update address bar
    const productUrl = root.dataset.url;
    if (productUrl) {
      history.replaceState({}, '', `${productUrl}?variant=${variant.id}`);
    }

    updatePieces(root, variant);
  }

  function init() {
    document.querySelectorAll('variant-selects, variant-radios').forEach(el => {
      el.removeEventListener('change', onChange);
      el.addEventListener('change', onChange);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
